import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  createEngineCc,
  getEngineCc,
  getEngineCcs,
  editEngineCc,
  deleteEngineCc,
} from "api/engineCcApi";

export const ENGINE_CC_QUERY_KEY = "engine-ccs";

export const useEngineCcs = (params = {}, enabled=true) => {
  return useQuery({
    queryKey: [ENGINE_CC_QUERY_KEY, params],
    queryFn: () => getEngineCcs(params),
    keepPreviousData: true,
    enabled
  });
};

export const useEngineCc = (id) => {
  return useQuery({
    queryKey: [ENGINE_CC_QUERY_KEY, id],
    queryFn: () => getEngineCc(id),
    enabled: !!id,
  });
};

export const useCreateEngineCc = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createEngineCc,
    onSuccess: (data) => {
      if (data?.success) {
        queryClient.invalidateQueries([ENGINE_CC_QUERY_KEY]);
      }
    },
  });
};

export const useEditEngineCc = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: editEngineCc,
    onSuccess: (data) => {
      if (data?.success) {
        queryClient.invalidateQueries([ENGINE_CC_QUERY_KEY]);
      }
    },
  });
};

export const useDeleteEngineCc = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteEngineCc,
    onSuccess: (data) => {
      if (data?.success) {
        queryClient.invalidateQueries([ENGINE_CC_QUERY_KEY]);
      }
    },
  });
};
